import { render, staticRenderFns } from "./blue-pop.vue?vue&type=template&id=5f82ecda&scoped=true"
import script from "./blue-pop.vue?vue&type=script&lang=ts"
export * from "./blue-pop.vue?vue&type=script&lang=ts"
import style0 from "./blue-pop.vue?vue&type=style&index=0&id=5f82ecda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f82ecda",
  null
  
)

export default component.exports